/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const NOT_FOUND_ERROR_TABLE_STRINGS = {
  heading: '50 highest 404 errors',
  numberOfErrors: 'Number of errors',
  totalAmount: 'Total amount of 404 errors in the last {{days}} days',
};
